import * as React from 'react';
import c from 'classnames';

import './style.scss';

type Props = {
  type?: 'primary' | 'secondary';
  className?: string;
};

const Block: React.FC<Props> = (props) => {
  const {
    children,
    type = 'primary',
    className,
  } = props;

  const classnames = c('Block', `Block--${type}`, className);

  return (
    <div className={classnames}>
      {children}
    </div>
  );
};

export default Block;
